module.exports = __webpack_public_path__ + "static/media/IMG_20240527_180148.cbac9349.png";